import React, { memo } from 'react'

import { arrayOf, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { viewLabelKey } from 'Pods/ThreeDStudio/Shared/Utils/viewLabelKeys'

function MultiViewPreview({ views }) {
  const t = useTranslation()

  return (
    <div className="collapsed-model-settings__image-grid">
      {views.map(({ viewType, url }) => (
        <img
          key={viewType}
          src={url}
          alt={t('shared.actionSelector.imageUploader.multiView.preview', { view: t(viewLabelKey(viewType)) })}
          className="collapsed-model-settings__image-tile"
          decoding="async"
        />
      ))}
    </div>
  )
}

MultiViewPreview.propTypes = {
  views: arrayOf(shape({
    viewType: string.isRequired,
    url: string.isRequired,
  })).isRequired,
}

export default memo(MultiViewPreview)
